import { useEffect, useState } from 'react';
import { clsx } from 'clsx';

import { TextField } from '@atom/mui';
import { TaskField } from '@atom/types/task';
import { PREVIEW_FIELD_WIDTH } from '@atom/utilities/taskUtilities';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import classes from './taskFields.module.css';

interface Props {
  field: TaskField;
  taskId?: string;
  onChange: (fieldId: string, value: any) => void;
  onBlur: (fieldId: string, value: any) => void;
  isDisabled?: boolean;
  error?: boolean;
  helperText?: string;
  onClick?: () => void;
}

const TaskNumericField = ({
  field,
  taskId,
  onChange,
  onBlur,
  isDisabled,
  error,
  helperText,
  onClick,
}: Props) => {
  const [value, setValue] = useState<any>(
    !isNilOrEmpty(field?.value) ? field?.value : '',
  );

  useEffect(() => {
    setValue(!isNilOrEmpty(field?.value) ? field?.value : '');
  }, [taskId, field?.id]);

  const handleChange = event => {
    const number =
      event.target.value === '' ? '' : parseFloat(event.target.value);
    setValue(number);
    onChange(field.id, number);
  };

  const handleOnBlur = event => {
    const number =
      event.target.value === '' ? '' : parseFloat(event.target.value);

    if (field?.value !== number) {
      setValue(number);
      onBlur(field.id, number);
    }
  };

  const containerWidth = {
    maxWidth: PREVIEW_FIELD_WIDTH,
  };

  const title = field.required ? `* ${field.title}` : field.title;
  const fieldUnit = field?.units ? ` (${field?.units})` : '';

  return (
    <div
      onClick={onClick}
      className={classes.fieldContainer}
      style={containerWidth}
    >
      <div
        className={clsx(classes.fieldTitle, error && classes.fieldTitleError)}
      >
        {title + fieldUnit}
      </div>
      <TextField
        id={field.id}
        style={containerWidth}
        type="number"
        value={value}
        disabled={isDisabled}
        onChange={handleChange}
        onBlur={handleOnBlur}
        error={error}
        helperText={helperText}
        onClick={onClick}
        data-cy={`taskField-${field.title}-NumberInput`}
      />
    </div>
  );
};

export default TaskNumericField;
